import { formatMoney } from "@greeter/formatters";
import { useToggle } from "@greeter/matter";

import css from "./MinPriceProgressBarCard.module.scss";
import { IconTrendingUp } from "@tabler/icons-react";
import { HTMLMotionProps, motion } from "motion/react";
import { classNames } from "@greeter/util";
import { Card, ProgressBar } from "@greeter/matter-v2";

const StatusTexts = {
  targetReached: () => "Minimum opnået!",
  youAreMissing: (args: { total: number }) =>
    `Du mangler ${formatMoney(args.total * -1)} kr.`,
};

export type MinPriceProgressBarCardProps = MinPriceProgressBarContentProps;
export function MinPriceProgressBarCard(props: MinPriceProgressBarCardProps) {
  return (
    <Card>
      <Card.Content>
        <MinPriceProgressBarContent {...props} />
      </Card.Content>
    </Card>
  );
}

export type MinPriceProgressBarContentProps = {
  value: number;
  target: number;
};
export function MinPriceProgressBarContent(
  props: MinPriceProgressBarContentProps
) {
  const [targetReached, toggleTargetReached] = useToggle(false);

  return (
    <div className={css.MinPriceProgressBarContent}>
      <span style={{ gridArea: "a", textAlign: "left" }} className={css.Hint}>
        Min. pris for dit bord
      </span>
      <ProgressBar
        style={{ gridArea: "c" }}
        onTargetReached={toggleTargetReached}
        onTargetUnreached={toggleTargetReached}
        value={props.value}
        target={props.target}
      />
      <span
        style={{
          gridArea: "d",
        }}
        className={css.StatusHint}
      >
        {!targetReached && (
          <>
            <IconTrendingUp className={css.TrendingUp} />
            {formatMoney(props.target - props.value)} kr. til minimum
          </>
        )}
        {targetReached && "🎉 Min. pris opfyldt for bord!"}
      </span>
      <span
        style={{ gridArea: "e", textAlign: "right" }}
        className={css.TargetPriceText}
      >
        {formatMoney(props.target)} kr.
      </span>
    </div>
  );
}

MinPriceProgressBarContent.TargetPriceText = function TargetPriceText(props: {
  style?: React.CSSProperties;
  target: number;
}) {
  return (
    <span
      style={{ textAlign: "right", ...props.style }}
      className={css.TargetPriceText}
    >
      {formatMoney(props.target)} kr.
    </span>
  );
};

MinPriceProgressBarContent.MissingAmountText = function MissingAmountText({
  className,
  ...props
}: {
  missing: number;
} & HTMLMotionProps<"span">) {
  return (
    <motion.span {...classNames(css.StatusHint, className)} {...props}>
      -{formatMoney(props.missing)}
    </motion.span>
  );
};
